import React from 'react'

import CounterChart from '../../_shared/charts/counter/CounterChart'
import ServiceOrdersCounterLoader, {
  useAllServiceOrdersCounter,
  useServiceOrdersCounter
} from './_load/ServiceOrdersCounterLoader'
import WidgetWrapper from '../../WidgetWrapper'
import { navigate } from '@reach/router'

const Widget = props => {
  const { widget } = props
  const value = useServiceOrdersCounter()
  const all = useAllServiceOrdersCounter()

  return <CounterChart value={value} all={all} name={widget.name} {...widget.data} />
}

const Wrapper = props => {
  const { widget } = props

  const onClick = widget?.data?.filters
    ? () => navigate(`service-orders/list?filters=${JSON.stringify(widget.data.filters)}`)
    : undefined

  return (
    <WidgetWrapper onClick={onClick} {...props}>
      <ServiceOrdersCounterLoader widget={widget}>
        <Widget widget={widget} />
      </ServiceOrdersCounterLoader>
    </WidgetWrapper>
  )
}

export default Wrapper
